import { AxiosResponse } from 'axios'
import { API } from '../config'
import { FarmDto, CreateFarmDTO, UpdateFarmDTO, FarmConfigDto, CreateFarmConfigDTO } from 'src/dto/farm.dto'

const BASE_URL = '/entity/Fazenda'
const CONFIG_BASE_URL = '/entity/FazendaConfiguracao'

export class FarmService {
  public async getFarmList(username: string): Promise<AxiosResponse<FarmDto[]>> {
    return await API.get(`/entity/hashKey/UsuarioPropriedade/${username}`)
  }

  public async getAllFarms(): Promise<AxiosResponse<FarmDto[]>> {
    return await API.get(BASE_URL)
  }

  public async createFarm(baseFarmId: string, payload: CreateFarmDTO): Promise<AxiosResponse<FarmDto>> {
    return await API.put(`${BASE_URL}/${baseFarmId}`, payload)
  }

  public async updateFarm(baseFarmId: string, payload: UpdateFarmDTO): Promise<AxiosResponse<FarmDto>> {
    return await API.put(`${BASE_URL}/${baseFarmId}`, payload)
  }

  public async createFarmConfig(payload: CreateFarmConfigDTO): Promise<AxiosResponse<FarmConfigDto>> {
    return await API.put(CONFIG_BASE_URL, payload)
  }
}
